import _inherits from "/codebuild/output/src2648725416/src/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/codebuild/output/src2648725416/src/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/codebuild/output/src2648725416/src/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _classCallCheck from "/codebuild/output/src2648725416/src/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/codebuild/output/src2648725416/src/node_modules/@babel/runtime/helpers/esm/createClass.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

import { Kind } from '../language/kinds.mjs';
import { visit } from '../language/visitor.mjs';
import { TypeInfo, visitWithTypeInfo } from '../utilities/TypeInfo.mjs';
/**
 * An instance of this class is passed as the "this" context to all validators,
 * allowing access to commonly useful contextual information from within a
 * validation rule.
 */

export var ASTValidationContext = /*#__PURE__*/function (_Symbol$toStringTag) {
  function ASTValidationContext(ast, onError) {
    _classCallCheck(this, ASTValidationContext);

    this._ast = ast;
    this._fragments = undefined;
    this._fragmentSpreads = new Map();
    this._recursivelyReferencedFragments = new Map();
    this._onError = onError;
  }

  _createClass(ASTValidationContext, [{
    key: _Symbol$toStringTag,
    get: function get() {
      return 'ASTValidationContext';
    }
  }, {
    key: "reportError",
    value: function reportError(error) {
      this._onError(error);
    }
  }, {
    key: "getDocument",
    value: function getDocument() {
      return this._ast;
    }
  }, {
    key: "getFragment",
    value: function getFragment(name) {
      var fragments;

      if (this._fragments) {
        fragments = this._fragments;
      } else {
        fragments = Object.create(null);

        var _iterator = _createForOfIteratorHelper(this.getDocument().definitions),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var defNode = _step.value;

            if (defNode.kind === Kind.FRAGMENT_DEFINITION) {
              fragments[defNode.name.value] = defNode;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        this._fragments = fragments;
      }

      return fragments[name];
    }
  }, {
    key: "getFragmentSpreads",
    value: function getFragmentSpreads(node) {
      var spreads = this._fragmentSpreads.get(node);

      if (!spreads) {
        spreads = [];
        var setsToVisit = [node];
        var set;

        while (set = setsToVisit.pop()) {
          var _iterator2 = _createForOfIteratorHelper(set.selections),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var selection = _step2.value;

              if (selection.kind === Kind.FRAGMENT_SPREAD) {
                spreads.push(selection);
              } else if (selection.selectionSet) {
                setsToVisit.push(selection.selectionSet);
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }

        this._fragmentSpreads.set(node, spreads);
      }

      return spreads;
    }
  }, {
    key: "getRecursivelyReferencedFragments",
    value: function getRecursivelyReferencedFragments(operation) {
      var fragments = this._recursivelyReferencedFragments.get(operation);

      if (!fragments) {
        fragments = [];
        var collectedNames = Object.create(null);
        var nodesToVisit = [operation.selectionSet];
        var node;

        while (node = nodesToVisit.pop()) {
          var _iterator3 = _createForOfIteratorHelper(this.getFragmentSpreads(node)),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var spread = _step3.value;
              var fragName = spread.name.value;

              if (collectedNames[fragName] !== true) {
                collectedNames[fragName] = true;
                var fragment = this.getFragment(fragName);

                if (fragment) {
                  fragments.push(fragment);
                  nodesToVisit.push(fragment.selectionSet);
                }
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }

        this._recursivelyReferencedFragments.set(operation, fragments);
      }

      return fragments;
    }
  }]);

  return ASTValidationContext;
}(Symbol.toStringTag);
export var SDLValidationContext = /*#__PURE__*/function (_ASTValidationContext, _Symbol$toStringTag2) {
  _inherits(SDLValidationContext, _ASTValidationContext);

  var _super = _createSuper(SDLValidationContext);

  function SDLValidationContext(ast, schema, onError) {
    var _this;

    _classCallCheck(this, SDLValidationContext);

    _this = _super.call(this, ast, onError);
    _this._schema = schema;
    return _this;
  }

  _createClass(SDLValidationContext, [{
    key: _Symbol$toStringTag2,
    get: function get() {
      return 'SDLValidationContext';
    }
  }, {
    key: "getSchema",
    value: function getSchema() {
      return this._schema;
    }
  }]);

  return SDLValidationContext;
}(ASTValidationContext, Symbol.toStringTag);
export var ValidationContext = /*#__PURE__*/function (_ASTValidationContext2, _Symbol$toStringTag3) {
  _inherits(ValidationContext, _ASTValidationContext2);

  var _super2 = _createSuper(ValidationContext);

  function ValidationContext(schema, ast, typeInfo, onError) {
    var _this2;

    _classCallCheck(this, ValidationContext);

    _this2 = _super2.call(this, ast, onError);
    _this2._schema = schema;
    _this2._typeInfo = typeInfo;
    _this2._variableUsages = new Map();
    _this2._recursiveVariableUsages = new Map();
    return _this2;
  }

  _createClass(ValidationContext, [{
    key: _Symbol$toStringTag3,
    get: function get() {
      return 'ValidationContext';
    }
  }, {
    key: "getSchema",
    value: function getSchema() {
      return this._schema;
    }
  }, {
    key: "getVariableUsages",
    value: function getVariableUsages(node) {
      var usages = this._variableUsages.get(node);

      if (!usages) {
        var newUsages = [];
        var typeInfo = new TypeInfo(this._schema);
        visit(node, visitWithTypeInfo(typeInfo, {
          VariableDefinition: function VariableDefinition() {
            return false;
          },
          Variable: function Variable(variable) {
            newUsages.push({
              node: variable,
              type: typeInfo.getInputType(),
              defaultValue: typeInfo.getDefaultValue()
            });
          }
        }));
        usages = newUsages;

        this._variableUsages.set(node, usages);
      }

      return usages;
    }
  }, {
    key: "getRecursiveVariableUsages",
    value: function getRecursiveVariableUsages(operation) {
      var usages = this._recursiveVariableUsages.get(operation);

      if (!usages) {
        usages = this.getVariableUsages(operation);

        var _iterator4 = _createForOfIteratorHelper(this.getRecursivelyReferencedFragments(operation)),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var frag = _step4.value;
            usages = usages.concat(this.getVariableUsages(frag));
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        this._recursiveVariableUsages.set(operation, usages);
      }

      return usages;
    }
  }, {
    key: "getType",
    value: function getType() {
      return this._typeInfo.getType();
    }
  }, {
    key: "getParentType",
    value: function getParentType() {
      return this._typeInfo.getParentType();
    }
  }, {
    key: "getInputType",
    value: function getInputType() {
      return this._typeInfo.getInputType();
    }
  }, {
    key: "getParentInputType",
    value: function getParentInputType() {
      return this._typeInfo.getParentInputType();
    }
  }, {
    key: "getFieldDef",
    value: function getFieldDef() {
      return this._typeInfo.getFieldDef();
    }
  }, {
    key: "getDirective",
    value: function getDirective() {
      return this._typeInfo.getDirective();
    }
  }, {
    key: "getArgument",
    value: function getArgument() {
      return this._typeInfo.getArgument();
    }
  }, {
    key: "getEnumValue",
    value: function getEnumValue() {
      return this._typeInfo.getEnumValue();
    }
  }]);

  return ValidationContext;
}(ASTValidationContext, Symbol.toStringTag);